
 <button mat-mini-fab color="accent" class="cancel-btn" aria-label="cancel-button" (click)="onConfirmClick()">
            <mat-icon>west</mat-icon>
        </button>
<mat-dialog-content > 
    <pdf-viewer [src]="dataLocalUrl" class="my-3"
                  [original-size]="false"
      ></pdf-viewer>
</mat-dialog-content>
